export var CONFIRM_MODALS_REDUCER_NAME = '@confirm-modal-module';
